import authApi from "@/queries/auth";
import userApi from "@/queries/master/user";
import roleApi from "@/queries/master/role";
import categoryStoreApi from "@/queries/master/category-store";
import categoryGroupApi from "@/queries/master/category-store-group";
import departmentApi from "@/queries/master/department";
import positionApi from "@/queries/master/position";
import picApi from "@/queries/data/pic";
import itemApi from "@/queries/management/item";
import vesselTypeApi from "@/queries/master/vessel-type";
import vesselClassApi from "@/queries/master/vessel-class";
import unitApi from "@/queries/master/unit";
import vendorApi from "@/queries/master/vendor";
import varianApi from "@/queries/management/varian";
import vesselApi from "@/queries/master/vessel";
import roleGroupApi from "@/queries/master/role-group";
import menuApi from "@/queries/master/menu";
import userPicApi from "@/queries/data/user-pic"
import menuTreeApi from "@/queries/master/menu-tree"
import portApi from "@/queries/master/port"
import moduleApi from "@/queries/master/module"
import menuRoleAPi from "@/queries/master/menu-role"
import regionApi from "@/queries/master/region"
import accessPermissionApi from "@/queries/master/access-permission"
import logActivityApi from "./management/log-activity";
import dashboardGeneralApi from "./dashboard/general"
import shipManagementCompanyApi from "./master/ship-management-company"
import shipOwnerCompanyApi from "./master/ship-owner-company"
import cascadingSchemeApi from "./management/cascading-scheme"
import requisitionApi from "./management/requisition";
import requisitionItemApi from "./management/requisition-item";
import vesselItemApi from "./management/item-vessel";

export const API = {
  auth: authApi,
  user: userApi,
  role: roleApi,
  categoryStore: categoryStoreApi,
  categoryGroup: categoryGroupApi,
  department: departmentApi,
  position: positionApi,
  pic : picApi,
  item : itemApi,
  vesselType : vesselTypeApi,
  vesselClass : vesselClassApi,
  unit: unitApi,
  vendor: vendorApi,
  varian: varianApi,
  vessel: vesselApi,
  roleGroup: roleGroupApi,
  menu: menuApi,
  userPic: userPicApi,
  menuTree: menuTreeApi,
  port: portApi,
  module: moduleApi,
  menuRole: menuRoleAPi,
  region: regionApi,
  accessPermission: accessPermissionApi,
  logActivity: logActivityApi,
  dashboardGeneral: dashboardGeneralApi,
  shipManagementCompany: shipManagementCompanyApi,
  shipOwnerCompany: shipOwnerCompanyApi,
  cascadingScheme: cascadingSchemeApi,
  requisition: requisitionApi,
  requisitionItem: requisitionItemApi,
  vesselItem: vesselItemApi
};